import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

export const ProgressBar = styled.div`
  position: relative;

  &.small {
    max-width: ${size(26)};
    margin-left: auto;
    margin-right: auto;
  }
`;

export const Track = styled.div`
  background: ${theme.colors.button.disabled.default};
  height: ${size(0.5)};
  border-radius: ${size(1)};

  ${theme.screens.Md} {
    height: ${size(1)};
  }
`;

export const Progress = styled.div`
  background: ${theme.colors.bg.alt};
  height: 100%;
  border-radius: ${size(1)};
  transition: width 75ms ease-out;
`;
